export const PROSPECT_RESELLER_ROUTES = [
  '/resellermanagement/public',
  '/resellermanagement',
  '/reselleronboarding/resellerdetails',
  '/reselleronboarding/resellerdetails-v2',
  '/reselleronboarding/dashboard',
  '/reselleronboarding/successpage',
  '/reselleronboarding/docusign-redirect',
];

export const PROSPECT_RESELLER_PUBLIC_ROUTES = [
  '/reselleronboarding/landing',
  '/reselleronboarding/registration',
];
